import { storage } from "@core/storage/storage";
import { isNotNil } from "@utils/assert";

export class UserBannerManager {
	private readonly _hideValidatedAccountBannerStore = storage.getStore<string[], string[]>(
		"hideValidateBanner",
		v => v,
		v => v,
	);

	updateValidatedAccountBanner(userId: string): void {
		if (isNotNil(userId))
			this._hideValidatedAccountBannerStore.setItem({
				...this._hideValidatedAccountBannerStore.getItem(),
				[userId]: true,
			});
	}

	hasValidatedAccountBanner(userId: string): boolean {
		const storeItems = this._hideValidatedAccountBannerStore.getItem();
		return isNotNil(storeItems) && isNotNil(userId) && Object.keys(storeItems).includes(userId);
	}
}
